/* global sessionStorage */
import React, { useState } from 'react'
import { useInstallPrompt } from '../../hooks/useInstallPrompt'

const DISMISS_KEY = 'mm_install_banner_dismissed'

function InstallBanner() {
  const { isStandalone, isIOSInstallable, canPromptInstall, promptInstall } = useInstallPrompt()
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === 'true')

  if (isStandalone || dismissed || !(canPromptInstall || isIOSInstallable)) {
    return null
  }

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, 'true')
    setDismissed(true)
  }

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 200,
        background: '#321b47',
        color: '#fff',
        padding: '0.75rem 1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.35)',
      }}
    >
      <div style={{ flex: 1, fontSize: '0.9rem', marginRight: '0.75rem' }}>
        {canPromptInstall && <span>Install Mayhem for the best experience</span>}
        {!canPromptInstall && isIOSInstallable && (
          <span>
            Tap <strong>Share</strong>, then <strong>Add to Home Screen</strong> to install Mayhem
          </span>
        )}
      </div>
      {canPromptInstall && (
        <button
          className="btn mayhem-btn-yellow"
          style={{ marginRight: '0.5rem', whiteSpace: 'nowrap' }}
          onClick={promptInstall}
        >
          Install
        </button>
      )}
      <button
        aria-label="Dismiss"
        onClick={handleDismiss}
        style={{
          background: 'transparent',
          border: 'none',
          color: '#fff',
          fontSize: '1.25rem',
          lineHeight: 1,
          cursor: 'pointer',
        }}
      >
        &times;
      </button>
    </div>
  )
}

export default InstallBanner
